import { useLayoutEffect, useRef } from 'react';

import PaddedContainer from '@kiosk/common/components/ui/PaddedContainer';
import ViewTasksLink from '@kiosk/common/components/UserPanel/ViewTasksLink/ViewTasksLink';
import FormScreenContainer from '@kiosk/common/components/ui/FormScreenContainer';
import FormContainer from '@kiosk/common/components/Forms/FormContainer';
import { FormFieldsContainer } from '@kiosk/common/components/Forms/FormFieldsContainer';
import { SMALL_DEVICE_HEIGHT } from '@kiosk/constants';
import Buttons from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/Buttons/Buttons';
import useTaskViewRenderers from '@kiosk/shiftTasks/helpers/useTaskViewRenderers';
import TimeClockNote from '@kiosk/timeClock/components/TimeClockNote';
import { useClockedInViewContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedInViewProvider/ClockedInViewProvider';
import AutomatedTimesheetEntries from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedTimesheetEntries/AutomatedTimesheetEntries';

const ClockedViewWithTaskWrapper = () => {
  const ref = useRef<HTMLDivElement>();
  const { shift, user, deviceHeight, usTimeFormat, timeClockNoteRef } = useClockedInViewContext();

  const { viewTasks, shortenAnimations, render, maxHeight, setMaxHeight } = useTaskViewRenderers({
    shift,
    user,
    deviceHeight,
    renderProp: renderClockInFields,
    baseScreenRef: ref
  });

  useLayoutEffect(() => {
    if (ref.current) {
      const { height: currentScreenHeight } = ref.current.getBoundingClientRect();
      if (currentScreenHeight > maxHeight) {
        setMaxHeight(currentScreenHeight);
      }
    }
  });

  const hasTasks = Boolean(shift?.taskInstances?.length);

  function renderClockInFields() {
    const delay = shortenAnimations ? 0.2 : 1.2;

    return (
      <div ref={ref}>
        {hasTasks && <ViewTasksLink delay={delay} onClick={viewTasks} />}
        <FormScreenContainer>
          <FormContainer>
            <FormFieldsContainer deviceHeight={deviceHeight}>
              <PaddedContainer>
                {shift.timesheetProjections.map(projection => (
                  <AutomatedTimesheetEntries
                    key={projection.id}
                    projection={projection}
                    usTimeFormat={usTimeFormat}
                    initialAnimationDelay={delay}
                  />
                ))}

                <TimeClockNote delay={delay} ref={timeClockNoteRef} shift={shift} />
                {deviceHeight <= SMALL_DEVICE_HEIGHT && (
                  <Buttons shortenAnimations={shortenAnimations} />
                )}
              </PaddedContainer>
            </FormFieldsContainer>

            {deviceHeight > SMALL_DEVICE_HEIGHT && (
              <Buttons shortenAnimations={shortenAnimations} />
            )}
          </FormContainer>
        </FormScreenContainer>
      </div>
    );
  }

  return render();
};

export default ClockedViewWithTaskWrapper;
